import { h } from "preact";
import { useSelector } from "react-redux";

import AppFooter from "../components/AppFooter.jsx";
import AppHeader from "../components/AppHeader.jsx";
import AppLayout from "../components/AppLayout.jsx";
import PartnerListItem from "../components/PartnerListItem.jsx";

import i18n from "../i18n.js";
import partnerApi from "../api/partner.js";
import { selectCurrentUser } from "../store/index";
import { useEffect, useState } from "preact/hooks";

export default function ProfilePage(props) {
  const user = useSelector(selectCurrentUser);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [partners, setPartners] = useState([]);

  useEffect(async () => {
    setLoading(true);
    try {
      const result = await partnerApi.fetchAll();
      setPartners(result);
    } catch (err) {
      console.error(err);
    }
    setLoaded(true);
    setLoading(false);
  }, []);

  if (!user) {
    window.location.href = "/login";
    return;
  }

  return (
    <AppLayout
      header={<AppHeader title={i18n.t("pages.titles.marketplace")} />}
      footer={<AppFooter />}
      loading={loading}
    >
      {loaded && (
        <div class="partners-page mt-48">
          {partners.map((partner) => (
            <div class="partners-page__item">
              <PartnerListItem partner={partner} />
            </div>
          ))}
        </div>
      )}
    </AppLayout>
  );
}
